import script from "./hallbox.vue?vue&type=script&setup=true&lang=js"
export * from "./hallbox.vue?vue&type=script&setup=true&lang=js"

import "./hallbox.vue?vue&type=style&index=0&id=00cf36fc&scoped=true&lang=css"
import "./hallbox.vue?vue&type=style&index=1&id=00cf36fc&lang=css"

import exportComponent from "C:\\vue2023\\cmsmap2023\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00cf36fc"]])

export default __exports__